export enum FiatLicenses {
  Bulgaria = 'BULGARIA',
  Estonia = 'ESTONIA',
}
